export const STORAGE_KEY__CLIENT_CODE = 'selected-client-code';
export const STORAGE_KEY__AIRLINE = 'selected-airline';
export const CLIENT_CODE = 'BNX';
// export const AIRLINE = 'TB';
export const DRAWER_WIDTH = 250;

export const WARNING_ROUTEIGNORED = "Ignored"